import React, { useState } from "react"
import './GalleryPage.scss'
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import PosterCard from "../components/blocks/PosterCard";

function GalleryPage() {

    const [activeImageNum, setActiveImageNum] = useState(null);

    const handleClose = () => setActiveImageNum(null);
    const handleOpen = (imgNum) => setActiveImageNum(imgNum);

    return (
        <div className="gallery-page">
            <div className="up-part">
                <div className="up-image"></div>
                <div className="portrait-container">
                    <div className="portrait">
                        <div className="portrait-img"></div>
                    </div>
                </div>
                {/* <div className="potato">
                    <div className="potato-img"></div>
                    <div className="potato-txt">
                        картофельный бунт
                    </div>
                </div>
                <div className="flower"></div> */}
                <Container className="position-relative">
                    <div className="name-container">
                        <div className="name">
                            Владимир Иванович
                        </div>
                        <div className="dal">
                            ДАЛЬ
                        </div>
                    </div>
                </Container>
            </div>
            <div className="soon-part">
                <Container className="soon-container">
                    <div className="soon-bg">
                        <div className="soon-title-block">
                            <div className="soon-title">
                                <span className="color-blue">Погрузитесь</span> в виртуальную экспозицию о жизни и трудах Владимира Ивановича Даля
                            </div>
                        </div>
                        <div className="soon-text-block">
                            <div className="soon-text">
                                {/* {`скоро вы сможете погрузиться в виртуальную экспозицию о жизни и трудах Владимира Ивановича Даля`} */}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            <div className="poster-list">
                <Container>
                    <Row>
                        <Col lg={5}>
                            <PosterCard
                                num={1}
                                title={`Шесть профессий одного человека`}
                                description={`Владимир Иванович Даль лечил людей, путешествовал, писал сказки и собирал слова. Как один человек всё это успел? Посмотри постер и узнай, кто такой Владимир Даль.`}
                                isupper
                                first
                                onClick={() => handleOpen(1)}
                            />
                        </Col>
                        <Col lg={6}>
                            <PosterCard
                                num={2}
                                title={`Моряк, которого укачивало`}
                                description={`Даль мечтал о море, но у него была одна проблема: его сильно укачивало. Узнай, куда его привела жизнь после службы во флоте и что он делал в трёх разных городах.`}
                                onClick={() => handleOpen(2)}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-row">
                        <Col lg={6}>
                            <PosterCard
                                num={3}
                                title={`Учёный и путешественник. Сколько языков знал Владимир Даль?`}
                                description={`Даль изучал природу, много путешествовал и дружил с людьми разных народов. Посчитай, сколько языков он знал.`}
                                onClick={() => handleOpen(3)}
                            />
                        </Col>
                        <Col lg={5}>
                            <PosterCard
                                num={4}
                                title={`Тайное имя сказочника`}
                                description={`Даль писал сказки под другим именем, и это имя знали лучше, чем настоящее. Узнай, откуда взялся загадочный псевдоним и прочитай сказки, написанные Владимиром Далем.`}
                                isupper
                                onClick={() => handleOpen(4)}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-row">
                        <Col lg={5}>
                            <PosterCard
                                num={5}
                                title={`«Так сделайте словарь!»`}
                                description={`Одна встреча, одна поездка в Оренбург и одна книга в подарок изменили историю русского языка. Узнайте, что связывало В. И. Даля и А. С. Пушкина и кто уговорил Даля не бросать главный труд его жизни. Смотри постер!`}
                                isupper
                                onClick={() => handleOpen(5)}
                            />
                        </Col>
                        <Col lg={6}>
                            <PosterCard
                                num={6}
                                title={`Проверь свою смекалку`}
                                description={`Этим загадкам больше 150 лет, и они совсем не похожи на современные. Картинки подскажут ответ, но только внимательному зрителю. Проверь себя и позови друзей: кто отгадает больше?`}
                                onClick={() => handleOpen(6)}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-row">
                        <Col lg={6}>
                            <PosterCard
                                num={7}
                                title={`Мудрость в одной фразе`}
                                description={`Больше 30 000 пословиц и поговорок Даль услышал от крестьян, казаков и ремесленников по всей России. На постере собраны самые меткие из них с объяснениями.`}
                                onClick={() => handleOpen(7)}
                            />
                        </Col>
                        <Col lg={5}>
                            <PosterCard
                                num={8}
                                title={`200 000 слов за 50 лет`}
                                description={`Сколько времени нужно, чтобы записать язык целого народа? Даль потратил на это больше 50 лет, тысячи карточек и черновых тетрадей. Загляни в историю словаря и посмотри, как выглядело первое издание.`}
                                isupper
                                onClick={() => handleOpen(8)}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-row">
                        <Col lg={5}>
                            <PosterCard
                                num={9}
                                title={`Кто такой боярин и что носили на Руси?`}
                                description={`Кафтан, армяк, кика… Эти слова ты мог слышать в сказках, но знаешь ли ты, что они значат? Посмотри на картинки и пройди викторину: пять вопросов, пять правильных ответов.`}
                                isupper
                                onClick={() => handleOpen(9)}
                            />
                        </Col>
                        <Col lg={6}>
                            <PosterCard
                                num={10}
                                title={`От гусиного пера до смартфона`}
                                description={`Словарь, созданный полтора века назад, теперь помещается в кармане. Узнай, как наследие Даля живёт сегодня и почему оно нужно и тебе.`}
                                onClick={() => handleOpen(10)}
                            />
                        </Col>
                    </Row>
                </Container>

            </div>

            <Modal
                show={!!activeImageNum}
                onHide={handleClose}
                centered
                contentClassName="bg-transparent border-0 shadow-none"
                backdropClassName="custom-modal-backdrop"
            >
                {activeImageNum && (
                    <div className="modal-window">
                        <a className="btn" href={`${window.location.origin}/posters/A3-${activeImageNum}.pdf`} target="_blank" rel="noreferrer">
                            <div className="download-icon"></div>
                            <div className="btn-text">
                                {`скачать постер`}
                            </div>
                        </a>
                        <div className="image-container">
                            <button className="close-btn" onClick={handleClose} aria-label="Закрыть">
                                <div className="close-icon"></div>
                            </button>
                            <img
                                src={`${window.location.origin}/posters/A3-${activeImageNum}.jpg`}
                                alt=""
                                className="img-fluid mb-4"
                                style={{ maxHeight: '80vh', objectFit: 'contain' }}
                            />
                        </div>
                        <a className="btn" href={`${window.location.origin}/posters/Узнай_больше_Постер_${activeImageNum}.pdf`} target="_blank" rel="noreferrer">
                            <div className="more-icon"></div>
                            <div className="btn-text">
                                {`узнать больше`}
                            </div>
                        </a>
                    </div>
                )}
            </Modal >
        </div >
    );
}

export default GalleryPage;